export const canRemoveNetwork = (totalNetworks: number) => totalNetworks > 1;

export const canRemoveBranch = (branchCount: number) => branchCount > 1;

export const canRemoveSubBranch = () => true;

export const isMongoObjectId = (id?: string) =>
  typeof id === 'string' && /^[a-f\d]{24}$/i.test(id);

export const getUserCompletedOnboarding = () => {
  try {
    const storedUser = localStorage.getItem('user');
    const user = storedUser ? JSON.parse(storedUser) : null;
    return !!user?.completedOnboarding;
  } catch {
    return false;
  }
};

export const canDeleteNodeWithoutContentGuard = (
  nodeId: string,
  isOnboardingCompleted = getUserCompletedOnboarding(),
) => isOnboardingCompleted && !isMongoObjectId(nodeId);

export const PERSISTED_NODE_DELETE_MESSAGE =
  'לא ניתן למחוק ענף קיים לאחר הפעלת המערכת.';

export const getShowRemoveButton = ({
  isNetwork,
  isBranch,
  totalNetworkCount,
  networkBranchCount,
}: {
  isNetwork: boolean;
  isBranch: boolean;
  totalNetworkCount: number;
  networkBranchCount: number;
}) => {
  if (isNetwork) {
    return canRemoveNetwork(totalNetworkCount);
  }

  if (isBranch) {
    return canRemoveBranch(networkBranchCount);
  }

  return canRemoveSubBranch();
};
